<template>
  <el-drawer
    :visible.sync="drawerVisible"
    direction="rtl"
    :size="drawerSize"
    :with-header="false"
    :custom-class="customClass"
    :before-close="handleBeforeClose"
    append-to-body
    destroy-on-close
  >
    <div class="form-drawer-header">
      <div class="form-drawer-title-wrap">
        <span class="form-drawer-title-icon"><i :class="icon"></i></span>
        <span class="form-drawer-title">{{ title }}</span>
        <div class="form-drawer-header-actions">
          <el-button size="small" icon="el-icon-back" :disabled="loading" @click="handleClose">返回列表</el-button>
          <el-button type="success" size="small" :loading="loading" :disabled="loading" @click="$emit('save')">保存</el-button>
        </div>
      </div>
      <el-button size="small" icon="el-icon-close" class="form-drawer-close" aria-label="关闭" :disabled="loading" @click="handleClose"></el-button>
    </div>

    <div class="form-drawer-content">
      <slot></slot>
    </div>

    <div class="form-drawer-footer">
      <slot name="footer">
        <el-button size="small" :disabled="loading" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" :loading="loading" :disabled="loading" class="form-drawer-save" @click="$emit('save')">保 存</el-button>
      </slot>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'FormDrawer',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, required: true },
    width: { type: String, default: '50%' },
    icon: { type: String, default: 'el-icon-edit-outline' },
    loading: { type: Boolean, default: false },
    customClass: { type: String, default: 'shared-form-drawer' }
  },
  computed: {
    drawerVisible: {
      get () { return this.visible },
      set (value) { this.$emit('update:visible', value) }
    },
    drawerSize () {
      return window.innerWidth <= 768 ? '100%' : '50%'
    }
  },
  methods: {
    handleBeforeClose (done) {
      if (!this.loading) done()
    },
    handleClose () {
      if (this.loading) return
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
:deep(.shared-form-drawer) {
  background: var(--bg-page);
}

:deep(.shared-form-drawer .el-drawer__body) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.form-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 14px 20px;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-card);
}

.form-drawer-title-wrap {
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-drawer-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.form-drawer-header-actions .el-button + .el-button {
  margin-left: 0;
}

.form-drawer-title-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color, #2563eb);
}

.form-drawer-title {
  overflow: hidden;
  color: var(--text-main);
  font-size: 15px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-drawer-close {
  display: none !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-color: var(--border-color) !important;
  border-radius: 8px !important;
  color: var(--text-muted) !important;
}

.form-drawer-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-card);
}

.form-drawer-content :deep(.drawer-horizontal-form .el-form-item) {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.form-drawer-content :deep(.drawer-horizontal-form .el-form-item__label) {
  width: 150px !important;
  flex: 0 0 150px;
  padding: 0 16px 0 0 !important;
  color: var(--text-muted);
  font-weight: 600;
  line-height: 32px;
  text-align: left;
}

.form-drawer-content :deep(.drawer-horizontal-form .el-form-item__content) {
  min-width: 0;
  flex: 1;
  margin-left: 0 !important;
}

.form-drawer-content :deep(.drawer-horizontal-form .el-input),
.form-drawer-content :deep(.drawer-horizontal-form .el-select),
.form-drawer-content :deep(.drawer-horizontal-form .el-input-number) {
  width: 100%;
}

.form-drawer-content :deep(.drawer-horizontal-form .el-input__inner),
.form-drawer-content :deep(.drawer-horizontal-form .el-textarea__inner) {
  border-color: var(--border-color);
  border-radius: 8px;
}

.form-drawer-content :deep(.drawer-horizontal-form .el-input__inner:focus),
.form-drawer-content :deep(.drawer-horizontal-form .el-textarea__inner:focus) {
  border-color: var(--primary-color, #2563eb);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);
}

.form-drawer-footer {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-card);
}

.form-drawer-footer .el-button + .el-button {
  margin-left: 0;
}

.form-drawer-save {
  background-color: var(--primary-color, #2563eb) !important;
  border-color: var(--primary-color, #2563eb) !important;
  font-weight: 600 !important;
}

@media (max-width: 768px) {
  .form-drawer-content {
    margin: 8px;
    padding: 16px;
  }

  .form-drawer-content :deep(.drawer-horizontal-form .el-form-item) {
    display: block;
  }

  .form-drawer-content :deep(.drawer-horizontal-form .el-form-item__label) {
    width: 100% !important;
    padding-right: 0 !important;
  }
}
</style>
